import ValueObject from './ValueObject';

export default class Label extends ValueObject {
  equals(other) {
    if (!(other instanceof Label)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new Label(json);
  }
}
